import React, { useEffect } from 'react';
import flecha_abajo from '../../assets/img/Home/flecha-abajo.png';
import Footer from '../Footer';
import './Newsletter.css';
import UsePageMetadata from '../../hooks/UsePageMetadata';

const Newsletter = ({ white, guardarWhite, guardarWhiteCaso }) => {
  UsePageMetadata('Newsletter | INDIO Agencia Digital' ?? '');

  useEffect(() => {
    window.scrollTo(0, 0);
    guardarWhite(true);
    guardarWhiteCaso(true);
  }, [guardarWhite, guardarWhiteCaso]);

  return (
    <div>
      <section id='newsletter' className='max-width'>
        <div className='newsletter_header'>
          <div>
            <img src={flecha_abajo} alt='flecha' />
          </div>
          <p className='italic title_newsletter'>
            Suscríbase
            <span>/newsletter/</span>
          </p>
        </div>

        <div className='newsletter_contenido'>
          <p className='newsletter_copy'>
            Suscríbase para recibir un e-mail trimestral sobre productos digitales y experiencias digitales memorables.
          </p>

          <div id='mc_embed_shell'>
            <div id='mc_embed_signup'>
              <form
                action='https://guru.us20.list-manage.com/subscribe/post?u=3092d25e195605cac14f0f80c&amp;id=697965a9e6&amp;f_id=009163eef0'
                method='post'
                id='mc-embedded-subscribe-form'
                name='mc-embedded-subscribe-form'
                className='validate'
                target='_self'
                noValidate
              >
                <div id='mc_embed_signup_scroll'>
                  <div className='indicates-required'>
                    <span className='asterisk'>*</span> indicates required
                  </div>
                  <div className='mc-field-group'>
                    <label htmlFor='mce-EMAIL'>
                      Email <span className='asterisk'>*</span>
                    </label>
                    <input type='email' name='EMAIL' className='required email' id='mce-EMAIL' required defaultValue='' />
                  </div>
                  <div className='mc-field-group'>
                    <label htmlFor='mce-FNAME'>Nombre </label>
                    <input type='text' name='FNAME' className='text' id='mce-FNAME' defaultValue='' />
                  </div>
                  <div className='mc-field-group'>
                    <label htmlFor='mce-LNAME'>Apellido </label>
                    <input type='text' name='LNAME' className='text' id='mce-LNAME' defaultValue='' />
                  </div>
                  <div className='mc-field-group'>
                    <label htmlFor='mce-MMERGE6'>Organización </label>
                    <input type='text' name='MMERGE6' className='text' id='mce-MMERGE6' defaultValue='' />
                  </div>
                  <div className='mc-field-group'>
                    <label htmlFor='mce-MMERGE7'>Cargo </label>
                    <input type='text' name='MMERGE7' className='text' id='mce-MMERGE7' defaultValue='' />
                  </div>

                  <div id='mce-responses' className='clear foot'>
                    <div className='response' id='mce-error-response' style={{ display: 'none' }}></div>
                    <div className='response' id='mce-success-response' style={{ display: 'none' }}></div>
                  </div>

                  {/* real people should not fill this in and expect good things - do not remove this or risk form bot signups */}
                  <div aria-hidden='true' style={{ position: 'absolute', left: '-5000px' }}>
                    <input type='text' name='b_3092d25e195605cac14f0f80c_697965a9e6' tabIndex='-1' defaultValue='' />
                  </div>

                  <div className='optionalParent'>
                    <div className='clear foot'>
                      <button type='submit' name='subscribe' id='mc-embedded-subscribe' className='button'>
                        Subscribe
                      </button>
                      <p style={{ margin: '0px auto' }}>
                        <a href='http://eepurl.com/iXPrHE' title='Mailchimp - email marketing made easy and fun'>
                          <span style={{ display: 'inline-block', backgroundColor: 'black', borderRadius: '4px' }}>
                            <img
                              className='refferal_badge'
                              src='https://digitalasset.intuit.com/render/content/dam/intuit/mc-fe/en_us/images/intuit-mc-rewards-text-light.svg'
                              alt='Intuit Mailchimp'
                              style={{ width: '220px', height: '40px', display: 'flex', padding: '2px 0px', justifyContent: 'center', alignItems: 'center' }}
                            />
                          </span>
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className='clearfix'></div>
      </section>

      <Footer white={white} />
    </div>
  );
};

export default Newsletter;
